export const HTML_UPDATE_AVAILABLE = 'HTML_UPDATE_AVAILABLE';
export const PREFETCH_IMAGES = 'PREFETCH_IMAGES';
